import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeedbackRequest } from '../types/feedback/feedback-request';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private readonly url = environment.applicationApi;

  constructor(private http: HttpClient) { }

  submit(request: FeedbackRequest): Observable<void> {
    return this.http.post<void>(`${this.url}/v1/Feedback`, request);
  }
}
